import { CatalogAccessType } from "@bvhi/backend-api/apis/model/catalogAccessType";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@bvhi/ui-base";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const CatalogAccessTypeSelectField = () => {
  const { control, trigger } = useFormContext();
  const { t } = useTranslation(["catalogs", "enums"]);

  return (
    <FormControl>
      <FormLabel id="platform-access-type-label">{t("catalogs:catalogs.form.fields.catalog.access.type.label")}</FormLabel>
      <Controller
        control={control}
        name="platformCatalogAccessType"
        render={({ field: { onChange, value } }) => (
          <RadioGroup
            aria-labelledby="platform-access-type-label"
            row
            value={(value as string) || ""}
            onChange={(_event, value) => {
              onChange(value);
              void trigger("platformCatalogAccessMatchingBlocks");
            }}
          >
            <FormControlLabel control={<Radio />} label={t("enums:enums.catalog.access.type.public")} value={CatalogAccessType.PUBLIC} />
            <FormControlLabel
              control={<Radio />}
              label={t("enums:enums.catalog.access.type.all.customers")}
              value={CatalogAccessType.ALL_CUSTOMERS}
            />
            <FormControlLabel
              control={<Radio />}
              label={t("enums:enums.catalog.access.type.protected")}
              value={CatalogAccessType.PROTECTED}
            />
          </RadioGroup>
        )}
      />
    </FormControl>
  );
};
